import type { FaireProductEntity } from "../../entity_types/product";

export const p_zb2sx4cfs9: FaireProductEntity = {
  token: "p_zb2sx4cfs9",
  type: "product",
  name: "Happy Plaid Thank You Boxed Card Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl: "https://cdn.faire.com/fastly/449f16158f7eee7dfbfabcb1229c475c9f0e3a9704106a50deb317bf1a6d48ef.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/03be828af5467f350eb870afac505ed379c59ed854469db0a000a3434759ddea.jpeg",
    "https://cdn.faire.com/fastly/0241368a96ea320212f6175dda51f811656d1c760da079eac6a0e147beb81e2a.jpeg"
  ],
  priceDollars: 11,
  description: "We're mad for plaid and glad to be fully clad, just like our dad.",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:04.174Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
